module.exports = __webpack_public_path__ + "img/moai.02f36ce4.svg";